module.exports = __webpack_public_path__ + "static/media/owner-reporting.4e697b8c.png";